export enum SidebarMenuID {
  Account = 'accounting',
  Payroll = 'payroll',
}
